export default __webpack_public_path__ + "static/media/ic_settings_24.6f286878.svg";